import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { ListItem } from '../common/list-item';
import { Entity } from '@core/data/dto/entity';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Dto } from '@core/data/dto/dto';
import { PayScheduleSchema } from './pay-schedule.schema';
import { ListSortBy } from '../common/list-sort-by';
import { ListGroupBy } from '../common/list-group-by';
import { PayScheduleFrequency } from './pay-schedule-frequency';

@DtoForceConstructor
export class PaySchedule implements ListItem, Entity {
    public id: string;
    public name: string;
    public active: boolean;
    public selected: boolean;
    public payFrequency: PayScheduleFrequency;
    public label?: string;
    public loading: boolean = false;

    @DtoImport(PayScheduleSchema)
    static import(dto: Dto): any {
        return new PaySchedule(dto);
    }

    constructor(value?: any) {
        if (value) {

            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: PayScheduleSchema,
        },
    ])
    export(type?: DtoType): any {}

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        const isMatched: boolean = false;
        return isMatched;
    }

    /**
     * Validates if this item matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        let isMatching: boolean = true;
        return isMatching;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        let group: string = '';

        return group;
    }

    /**
     * Custom comparision used by sort.
     * Ref is the value to sort / compare by.
     * @param ref
     */
    valueOf(ref?: ListSortBy): any {
        return this;
    }
}